import { render } from "./FertilityCenter.vue?vue&type=template&id=0f0e4ff8"
import script from "./FertilityCenter.vue?vue&type=script&lang=ts"
export * from "./FertilityCenter.vue?vue&type=script&lang=ts"
script.render = render

export default script